import React, { useContext, useEffect, useState } from 'react'

import { getBackendData } from '../../api/api'
import { ITHORDistribution } from '../../api/interfaces'
import { ThemeContext } from '../../App'
import { IChart, IChartConfig } from '../../components/Chart/interface'
import LoadingChart from '../../components/LoadingIcon/Loading'
import ChartPage from '../../pages/ChartPage/ChartPage'
import { useChartData } from '../../hooks/useChartData'

export async function getTSThorDistributionConfig(color: string, inverseColor: string, timeframe: string) {
	const chartData = (await getBackendData('thorswap', 'thor_distribution', timeframe)) as ITHORDistribution[]
	const series1 = chartData.map((element: ITHORDistribution) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.RICH_COUNT_50K }
	})
	const series2 = chartData.map((element: ITHORDistribution) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.RICH_COUNT_10K }
	})
	const series3 = chartData.map((element: ITHORDistribution) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.RICH_COUNT_1K }
	})
	const config: IChart[] = [
		{
			data: series1,
			strokeWidth: 2,
			name: 'wallets with >= 50k [thor]',
			type: 'line',
			seriesGroup: '[wallet #]',
			color: 'green',
			unitSymbol: ''
		},
		{
			data: series2,
			strokeWidth: 2,
			name: 'wallets with >= 10k [thor]',
			type: 'line',
			seriesGroup: '[wallet #]',
			color: 'orange',
			unitSymbol: ''
		},
		{
			data: series3,
			strokeWidth: 2,
			name: 'wallets with >= 1k [thor]',
			type: 'line',
			seriesGroup: '[wallet #]',
			color: `${color}`,
			unitSymbol: ''
		}
	]
	return { config: config, latestValue: series2[series2.length - 1].y, latestValueDate: series2[series2.length - 1].x }
}

const TSThorDistribution = () => {
	const { dataSeries, timeframe, setTimeframe, isLoading, error, retry } = useChartData(getTSThorDistributionConfig, '1m')

	if (error) {
		return (
			<div style={{ padding: 40, textAlign: 'center' }}>
				<p>Error loading chart: {error}</p>
				<button onClick={retry}>Retry</button>
			</div>
		)
	}

	if (isLoading || dataSeries === undefined) {
		return <LoadingChart />
	}
	return (
		<ChartPage
			chartTitle="THOR Distribution"
			chartDesc="Distribution of THOR token holdings across different value brackets."
			chartDescTitle="Metric Description"
			chartData={dataSeries.config}
			queryId="b1a144ba-bd3b-493a-9b3f-42ebdfc9c2a5"
			timeframe={timeframe}
			setTimeframe={setTimeframe}
			hasHours={false}
			hasLogScale={true}
		/>
	)
}

export default TSThorDistribution
